import Vue from 'vue'
import {
  Button,
  Image,
  Input,
  Form,
  FormItem,
  Checkbox,
  Pagination,
  Table,
  TableColumn
} from 'element-ui'

const components = [
  Button,
  Image,
  Input,
  Form,
  FormItem,
  Checkbox,
  Pagination,
  Table,
  TableColumn
]

for (const component of components) {
  Vue.component(component.name, component)
}
